export default function getBaseDomainWithoutApp() {
  const gOrigin = window.location.origin;
  const gHost = new URL(gOrigin).hostname;

  // Check if we're on localhost
  if (gHost.includes('localhost')) {
    return gHost;
  }

  const splitedDomain = gHost.split('.');

  // Remove 'app.' prefix if it exists
  // e.g., app.tweek.io -> tweek.io, app.stagepanda.com -> stagepanda.com
  if (splitedDomain[0] === 'app') {
    splitedDomain.shift();
  }

  const domain = `${splitedDomain.at(-2)}.${splitedDomain.at(-1)}`;

  return domain;
}
